import React, { useEffect, useState } from 'react';
import { capitalize } from '@material-ui/core';
import PreviewImage from '../../PreviewImage';
import { stripImageTypeName } from './functions';
import styles from './MultiPose.module.scss';

export default function ProgressSheets({ sheets, index }) {
  const [maxIndex, setMaxIndex] = useState(index);

  useEffect(() => {
    if (index < maxIndex) return;

    setMaxIndex(index);
  }, [index]);

  return (
    <div>
      <h3 className={styles.progressTitle}>Your Sheets</h3>
      <div className={styles.progressSheetsWrapper}>
        {sheets.filter((_sheet, i) => i <= maxIndex).map((sheet) => {
          const nameWithoutNum = stripImageTypeName(sheet.imageType);

          return (
            <div className={styles.progressSheet}>
              <span className={styles.title}>{capitalize(nameWithoutNum)}</span>
              <PreviewImage
                actualForegroundUrl={sheet.foreground && sheet.foreground.imageUrl}
                foregroundUrl={sheet.pose && (sheet.pose.watermarkUrl || sheet.pose.imageUrl)}
                backgroundUrl={sheet.background && sheet.background.imageUrl}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
